import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import GestionarMoneda from "./configuracionGeneral/gestionDeMonedas";
import TablaUsuariosApp from "./configuracionGeneral/tablaUsuriosApp";
import TablaUsuarios from "./configuracionGeneral/tablaUsurios";
import TablaOrganizacion from "./configuracionGeneral/tablaOrganizacion";
import TablaPersonas from "./configuracionGeneral/tablaPersonas";
import GenerarBackup from "./configuracionGeneral/generarBackup";
import TablaMonedas from "./configuracionGeneral/tablaMonedas";
import TablaAfiliados from "./configuracionGeneral/tablaAfiliados";
import TablaAjustesSistema from "./configuracionGeneral/tablaAjuste";
import ReportesConfig from "./configuracionGeneral/reportesConfig";
import Auditoria from "./configuracionGeneral/auditoria";
import { usuarioAuditoria } from "../util/varios";

export const VerConfiguracion = (props) => {
  const [mostrar, setMostrar] = useState(0);
  const [clase, setClase] = useState("d-flex bluex-bg");
  const accconfiggene = JSON.parse(sessionStorage.getItem("accconfiggene"));
  const [msg1, setMsg1] = useState("Gestionar Organización");
  /* la Auditoria solo la pueden ver los usuarios autorizados (ver varios.js) */
  const puedeAuditoria = usuarioAuditoria();

  const mostrarHomologacion = () => {
    window.open(
      "https://www.athos.com.ve/api/imagen?img=solicitud_athos.pdf",
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const mostrarManual = () => {
    window.open(
      `/pdf/Manual_Usuario_Atho_ERP.pdf`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };


  const mostrarVis = (vista) => (e) => {
    e.preventDefault();
    setMostrar(vista);
  };

  const cancelar = () => {
    setMostrar("");
    setClase("d-flex bluex-bg");
    props.onHideCancela();
  };

  const menuclick = (titulo) => (e) => {
    e.preventDefault();
    setMsg1(titulo);
    if (clase === "d-flex bluex-bg") {
      setClase("d-flex bluex-bg toggled");
    } else {
      setClase("d-flex bluex-bg");
    }
  };

  const VISTA = {
    0: "",
    1: <TablaOrganizacion />,
    2: <TablaPersonas />,
    3: <TablaUsuarios menu={"organizacion"} />,
    4: <TablaUsuariosApp menu={"organizacion"} />,
    5: <TablaMonedas />,
    6: <GestionarMoneda />,
    7: <GenerarBackup menu={"organizacion"} />,
    8: <TablaAjustesSistema />,
    10: <ReportesConfig />,
    /* la vista de Auditoria solo se monta para los usuarios autorizados */
    ...(puedeAuditoria && { 11: <Auditoria /> }),
  };

  return (
    <Modal
      {...props}
      size="xl"
      dialogClassName="modal-config-general"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Configuración General</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>

      <Modal.Body className="conf-modal-body" style={{ padding: 0 }}>
        <div className={`${clase} conf-modal`} id="wrapper">
          <div className="amanecergris" id="sidebar-wrapper">
            <div className="list-group list-group-flush ">
              <div className="list-group list-group-flush">
                <ul className="list-group list-group-light">
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Gestionar Organización")}
                  >
                    <a
                      style={{
                        pointerEvents:
                          accconfiggene && accconfiggene.substring(0, 1) === "0"
                            ? "none"
                            : "cursor",
                        color:
                          accconfiggene && accconfiggene.substring(0, 1) === "0"
                            ? "rgb(183, 183, 183)"
                            : "#1d0345",
                        backgroundColor:
                          accconfiggene && accconfiggene.substring(0, 1) === "0"
                            ? "rgba(144, 143, 142, 0.76)"
                            : "transparent",
                      }}
                      className="list-group-item list-group-item-action py-3 ripple px-1"
                      type="button"
                      onClick={mostrarVis(1)}
                    >
                      <i className="  fas fa-sitemap fa-fw me-3 px-2"></i>
                      <span className=" fw-bold">Organizacion</span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Gestionar Ajustes")}
                  >
                    <a
                      style={{
                        pointerEvents:
                          accconfiggene && accconfiggene.substring(6, 7) === "0"
                            ? "none"
                            : "cursor",
                        color:
                          accconfiggene && accconfiggene.substring(6, 7) === "0"
                            ? "rgb(183, 183, 183)"
                            : "#1d0345",
                        backgroundColor:
                          accconfiggene && accconfiggene.substring(6, 7) === "0"
                            ? "rgba(144, 143, 142, 0.76)"
                            : "transparent",
                      }}
                      className="list-group-item list-group-item-action py-3 ripple px-1"
                      type="button"
                      onClick={mostrarVis(8)}
                    >
                      <i className="fas fa-wrench fa-fw me-3 px-2"></i>
                      <span className="fw-bold">Ajustes</span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Gestionar Personas")}
                  >
                    <a
                      style={{
                        pointerEvents:
                          accconfiggene && accconfiggene.substring(1, 2) === "0"
                            ? "none"
                            : "cursor",
                        color:
                          accconfiggene && accconfiggene.substring(1, 2) === "0"
                            ? "rgb(183, 183, 183)"
                            : "#1d0345",
                        backgroundColor:
                          accconfiggene && accconfiggene.substring(1, 2) === "0"
                            ? "rgba(144, 143, 142, 0.76)"
                            : "transparent",
                      }}
                      className="list-group-item list-group-item-action py-3 ripple px-1"
                      type="button"
                      onClick={mostrarVis(2)}
                    >
                      <i className="  fas fa-user-alt fa-fw me-3  px-2" />
                      <span className=" fw-bold">Personas</span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Gestionar Usuarios")}
                  >
                    <a
                      style={{
                        pointerEvents:
                          accconfiggene && accconfiggene.substring(2, 3) === "0"
                            ? "none"
                            : "cursor",
                        color:
                          accconfiggene && accconfiggene.substring(2, 3) === "0"
                            ? "rgb(183, 183, 183)"
                            : "#1d0345",
                        backgroundColor:
                          accconfiggene && accconfiggene.substring(2, 3) === "0"
                            ? "rgba(144, 143, 142, 0.76)"
                            : "transparent",
                      }}
                      className="list-group-item list-group-item-action py-3 ripple px-1"
                      type="button"
                      onClick={mostrarVis(3)}
                    >
                      <i className="  fas fa-user-check fa-fw me-3  px-2" />
                      <span className=" fw-bold">Usuarios</span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Gestionar Usuarios App")}
                  >
                    <a
                      style={{
                        pointerEvents:
                          accconfiggene && accconfiggene.substring(5, 6) === "0"
                            ? "none"
                            : "cursor",
                        color:
                          accconfiggene && accconfiggene.substring(5, 6) === "0"
                            ? "rgb(183, 183, 183)"
                            : "#1d0345",
                        backgroundColor:
                          accconfiggene && accconfiggene.substring(5, 6) === "0"
                            ? "rgba(144, 143, 142, 0.76)"
                            : "transparent",
                      }}
                      className="list-group-item list-group-item-action py-3 ripple px-1"
                      type="button"
                      onClick={mostrarVis(4)}
                    >
                      <i className="  fas fa-user-check fa-fw me-3  px-2" />
                      <span className=" fw-bold">Usuarios App</span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Gestionar Monedas")}
                  >
                    <a
                      style={{
                        pointerEvents:
                          accconfiggene && accconfiggene.substring(3, 4) === "0"
                            ? "none"
                            : "cursor",
                        color:
                          accconfiggene && accconfiggene.substring(3, 4) === "0"
                            ? "rgb(183, 183, 183)"
                            : "#1d0345",
                        backgroundColor:
                          accconfiggene && accconfiggene.substring(3, 4) === "0"
                            ? "rgba(144, 143, 142, 0.76)"
                            : "transparent",
                      }}
                      className="list-group-item list-group-item-action py-3 ripple px-1"
                      type="button"
                      onClick={mostrarVis(5)}
                    >
                      <i className="  fas fa-money-bill fa-fw me-3 px-2" />
                      <span className=" fw-bold">Monedas</span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Gestionar Tasas de Cambio")}
                  >
                    <a
                      style={{
                        pointerEvents:
                          accconfiggene && accconfiggene.substring(3, 4) === "0"
                            ? "none"
                            : "cursor",
                        color:
                          accconfiggene && accconfiggene.substring(3, 4) === "0"
                            ? "rgb(183, 183, 183)"
                            : "#1d0345",
                        backgroundColor:
                          accconfiggene && accconfiggene.substring(3, 4) === "0"
                            ? "rgba(144, 143, 142, 0.76)"
                            : "transparent",
                      }}
                      className="list-group-item list-group-item-action py-3 ripple px-1"
                      type="button"
                      onClick={mostrarVis(6)}
                    >
                      <i className="fas fa-chart-line fa-fw me-3 px-2" />
                      <span className=" fw-bold">Tasa de Cambio</span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Generar Respaldo")}
                  >
                    <a
                      style={{
                        pointerEvents:
                          accconfiggene && accconfiggene.substring(4, 5) === "0"
                            ? "none"
                            : "cursor",
                        color:
                          accconfiggene && accconfiggene.substring(4, 5) === "0"
                            ? "rgb(183, 183, 183)"
                            : "#1d0345",
                        backgroundColor:
                          accconfiggene && accconfiggene.substring(4, 5) === "0"
                            ? "rgba(144, 143, 142, 0.76)"
                            : "transparent",
                      }}
                      className="list-group-item list-group-item-action py-3 ripple px-1"
                      type="button"
                      onClick={mostrarVis(7)}
                    >
                      <i className="  fas fa-database fa-fw me-3 px-2" />
                      <span className="fw-bold">Respaldar</span>
                    </a>
                  </li>
                  <li
                    className="list-group-item bg-transparent px-0 p-0 btn-primary"
                    onClick={menuclick("Impresion de Reportes")}
                  >
                    <a
                      style={{
                        pointerEvents:
                          accconfiggene && accconfiggene.substring(4, 5) === "0"
                            ? "none"
                            : "cursor",
                        color:
                          accconfiggene && accconfiggene.substring(4, 5) === "0"
                            ? "rgb(183, 183, 183)"
                            : "#1d0345",
                        backgroundColor:
                          accconfiggene && accconfiggene.substring(4, 5) === "0"
                            ? "rgba(144, 143, 142, 0.76)"
                            : "transparent",
                      }}
                      className="list-group-item list-group-item-action py-3 ripple px-1"
                      type="button"
                      onClick={mostrarVis(10)}
                    >
                      <i className="  fas fa-database fa-fw me-3 px-2" />
                      <span className="fw-bold">Impresion de Reportes</span>
                    </a>
                  </li>
                  {puedeAuditoria && (
                    <li
                      className="list-group-item bg-transparent px-0 p-0 btn-primary"
                      onClick={menuclick("Gestionar Auditoría")}
                    >
                      <a
                        style={{
                          pointerEvents: "cursor",
                          color: "#1d0345",
                          backgroundColor: "transparent",
                        }}
                        className="list-group-item list-group-item-action py-3 ripple px-1"
                        type="button"
                        onClick={mostrarVis(11)}
                      >
                        <i className="fas fa-history fa-fw me-3 px-2" />
                        <span className="fw-bold">Auditoría</span>
                      </a>
                    </li>
                  )}
                  <li className="list-group-item bg-transparent px-0 p-0 btn-primary">
                    <btn
                      style={{
                        pointerEvents: "cursor",
                        color: "#1d0345",
                        backgroundColor: "transparent",
                      }}
                      className="list-group-item list-group-item-action py-3 ripple px-1"
                      type="button"
                      onClick={mostrarHomologacion}
                    >
                      <i className="  fas fa-file fa-fw me-3 px-2" />
                      <span className="fw-bold">Homologación Seniat</span>
                    </btn>
                  </li>
                  <li className="list-group-item bg-transparent px-0 p-0 btn-primary">
                    <btn
                      style={{
                        pointerEvents: "cursor",
                        color: "#1d0345",
                        backgroundColor: "transparent",
                      }}
                      className="list-group-item list-group-item-action py-3 ripple px-1"
                      type="button"
                      onClick={mostrarManual}
                    >
                      <i className="  fas fa-file fa-fw me-3 px-2" />
                      <span className="fw-bold">Manual de Usuario</span>
                    </btn>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div
            className="conf-modal-overlay"
            onClick={menuclick(msg1)}
            aria-hidden="true"
          ></div>

          <div id="page-content-wrapper">
            <nav
              className="navbar navbar-expand-lg navbar-light py-2 px-2"
              id="one"
              style={{ background: "none" }}
            >
              <div className="d-flex align-items-center">
                <i
                  className="fas fa-align-left  text-dark fs-4 me-3"
                  onClick={menuclick(msg1)}
                  id="menu-toggle"
                />
              </div>
              <div
                className="collapse navbar-collapse dropstart"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav mx-auto text-center">
                  <h4 className="fs-4">
                    {msg1 === "Valor Petro" ? (
                      <i className="fas fa-lg fa-lg px-2 fa-ruble-sign" />
                    ) : msg1 === "Valor UTE" ? (
                      <i className="  fas fa-chart-line fa-lg px-2 " />
                    ) : msg1 === "Gestion de Usuario Web" ? (
                      <i className="  fas fa-users-cog fa-lg px-2" />
                    ) : msg1 === "Estructura Organizativa" ? (
                      <i className="  fas fa-user-tie fa-lg px-2" />
                    ) : (
                      ""
                    )}
                    {msg1 === 0 ? "INICIO" : msg1}
                  </h4>
                </ul>
              </div>
            </nav>

            <div className="container-fluid mx-auto py-3" id="scrolty">
              {VISTA[mostrar]}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/modalVerConfiguracion.js